import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axiosInstance from "./AxiosInstance";

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      setIsAuthenticated(false);
      setChecking(false);
      return;
    }

    const verifyToken = async () => {
      try {
        
        const response = await axiosInstance.post("/auth/user", { token });

        if (response.data) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Auth error:", error);
        setIsAuthenticated(false);
      } finally {
        setChecking(false);
      }
    };

    verifyToken();
  }, []);

  if (checking || isAuthenticated === null) {
    return <div className="text-center mt-10 text-xl">Checking authentication...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/not-found" />;
  }

  return children;
};

export default ProtectedRoute;
